import '../../variables.css';
export { default } from './Tooltip';
